import { AnalyticsLogger } from './AnalyticsLogger'
import { AnalyticsEvent } from './AnalyticsEvents'
import { logDebug, logErrorDebug } from '../debug/debugLogging'

interface WithDataLayer {
  dataLayer: {
    push(event: unknown): void
  }
}

export class GtmAnalyticsLogger implements AnalyticsLogger {
  private hasLoggedPageView = false

  log(event: AnalyticsEvent) {
    if (event.event === 'page_view') {
      this.hasLoggedPageView = true
    }

    if (!this.hasLoggedPageView) {
      logErrorDebug('GtmAnalyticsLogger', 'logging an event before page_view!', JSON.stringify(event, null, 4))
    } else {
      logDebug('GtmAnalyticsLogger', 'logging event', JSON.stringify(event, null, 4))
    }

    try {
      // Push null for ecommerce before pushing the actual ecommerce value in the event
      // This was a business requirement in the analytics rebuild
      if (event.hasOwnProperty('ecommerce')) {
        (window as unknown as WithDataLayer).dataLayer.push({ 'ecommerce': null })
      }

      (window as unknown as WithDataLayer).dataLayer.push(event)
    } catch (e) {
      logErrorDebug('GtmAnalyticsLogger', 'error logging to GTM', e)
    }
  }
}